import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '../../store';
import { logOut } from '../../store/auth/authActions';
import useDesktopSize from '../../../utils/hooks/useDesktopSize';
import EAButton from '../shared/Buttons/EAButton';
import EAIconButton from '../shared/Buttons/EAIconButton';
import { MdOutlineLogout } from 'react-icons/md';

const MyAccountHeader: React.FC = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state: State) => state.auth.userData);
  const isDesktop = useDesktopSize();

  const handleLogout = () => {
    dispatch(logOut());
  };

  return (
    <div className="my-account-v2__header">
      <h2>Cześć, {userData.firstName}</h2>
      {isDesktop ? (
        <EAButton title="Wyloguj się" onClick={handleLogout} variant="text" endIcon={<MdOutlineLogout />} />
      ) : (
        <EAIconButton title="Wyloguj się" icon={<MdOutlineLogout />} onClick={handleLogout} variant="icon" />
      )}
    </div>
  );
};

export default MyAccountHeader;
